// #ux-redesign: picker de adjuntos para el form de redaccion.
// Reemplaza el componente BtnAttach (boton azul con FileList por instancia +
// state derivado en attachmentList[]). El picker maneja un input file oculto
// que dispara `onPick(File)` por cada seleccion. Los chips + el state lo
// maneja el padre (InboxViewForm), simplificando el flujo.
//
// Por que ya no se usa react-hook-form para los archivos: con RHF v5 y
// names "attachments[N]" las FileLists no llegaban consistente al onSubmit
// (a veces undefined, a veces object {0: FileList}). El sintoma era
// "envio sin error pero archivos no recuperados". Ahora el state es plano
// en el padre y se entrega como File[] al saga.
// ─────────────────────────────────────────────────────────────────────────────
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslate } from 'react-translate';
import { toast } from 'components/ds';
import fileRules from 'configs/fileRules';

const AttachmentPicker = ({ onPick, multiple = true }) => {
  const t = useTranslate('messages');
  const inputRef = useRef(null);

  const validateSize = (file) => {
    const maxBytes = parseInt(fileRules.maxSize, 10) * 1024 * 1024;
    return file.size <= maxBytes;
  };

  const handleChange = (e) => {
    const files = Array.from(e.target.files || []);
    files.forEach((f) => {
      if (!validateSize(f)) {
        toast.error(`${t('alert-error-size-file')} ${fileRules.maxSize} Mb`);
        return;
      }
      onPick(f);
    });
    // Reset para permitir re-seleccionar el mismo file
    e.target.value = '';
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept={fileRules.types.toString()}
        multiple={multiple}
        onChange={handleChange}
        className="d-none"
        data-testid="attachment-picker-input"
      />
      <button
        type="button"
        className="attach-picker-btn"
        onClick={() => inputRef.current && inputRef.current.click()}
      >
        <i className="fas fa-paperclip" aria-hidden="true" />
        <span>{t('btn-add-file') || 'Add file'}</span>
      </button>
    </>
  );
};

AttachmentPicker.propTypes = {
  onPick: PropTypes.func.isRequired,
  multiple: PropTypes.bool,
};

export default AttachmentPicker;
